import { useEffect, useState } from "react";
import axios from "axios";
import { useAccount } from "wagmi";

const GetNFTS = () => {
  const { address, connector, isConnected } = useAccount();
  const [data, setData] = useState([]);
  const nftListHandler = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/${address}`
      );

      return response.data;
    } catch (error) {
      console.error("Error in nftListHandler:", error);
      throw new Error("Unable to fetch NFT data");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await nftListHandler();
        console.log(data);
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="pt-5 mt-5">
      <div className="col-md-6 col-sm-12 bannerLeft">
        <div style={{ display: "flex", gap: "10px" }}>
          {data?.imageLinks?.map((list, index) => (
            <div style={{ display: "flex", gap: "20px", width: "100%" }}>
              <div
                style={{
                  position: "relative",
                  height: "100%",
                  width: "100%",
                }}
              >
                <div>
                  <img
                    style={{ width: "auto", height: "300px" }}
                    src={list.image}
                  />
                  <div>
                    <p>{list.prompt} </p>
                  </div>
                  <div className="bg-white" style={{width:"100%"}}>
                    <pre>
                      {JSON.stringify(data?.jsonObjects?.[index], null, 2)}
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default GetNFTS;
